export {default} from './copy_to_clipboard_button';
